import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-d",
  "use": "arrow-d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-d\"><defs><style>#arrow-d .cls-1{fill:none}</style></defs><title>资源 84</title><g id=\"arrow-d_图层_2\" data-name=\"图层 2\"><g id=\"arrow-d_图层_1-2\" data-name=\"图层 1\"><path id=\"arrow-d_Rectangle_36_Copy_6\" data-name=\"Rectangle 36 Copy 6\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"arrow-d_down\"><path id=\"arrow-d_Shape\" d=\"M21 7a1.08 1.08 0 0 1-.22.65l-8 9.93a1 1 0 0 1-1.44.16 1.21 1.21 0 0 1-.16-.16L3.23 7.72a1 1 0 0 1 .12-1.45 1 1 0 0 1 1.44.12.1.1 0 0 1 0 .05l7.21 8.9 7.19-8.95A1 1 0 0 1 21 7z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/arrow-d.svg
// module id = p06T
// module chunks = 6